export default __webpack_public_path__ + "static/media/net.a10a4f42.png";